import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ButtonModule} from '@aztrix/components/button';
import {PropertyViewModule} from '@aztrix/components/property-view';
import {TranslatePipe} from '@aztrix/translate';

import {EmailSignatureComponent} from './email-signature.component';

@NgModule({
  declarations: [EmailSignatureComponent],
  imports: [CommonModule, PropertyViewModule, ButtonModule, TranslatePipe],
  exports: [EmailSignatureComponent],
})
export class EmailSignatureModule {}
